/* global window */

import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './reducers'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const appStateStore = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(thunk),
  )
)

export default appStateStore



// WEBPACK FOOTER //
// ./src/store.js